import React from 'react';
import LegalLayout, { LegalSection } from '../components/LegalLayout';

export default function MentionsLegales() {
  return (
    <LegalLayout title="Mentions légales" lastUpdated="1er janvier 2025">
      <LegalSection title="1. Éditeur du site">
        <p>
          Le site <strong>Kurso</strong> (accessible à l'adresse mykurso.app) est édité par :
        </p>
        <ul className="list-disc pl-5 space-y-1 text-[#a0a0ab]">
          <li><strong className="text-[#e8e8e8]">Raison sociale :</strong> SAS Sanctuaire Consulting Services</li>
          <li><strong className="text-[#e8e8e8]">Forme juridique :</strong> Société par Actions Simplifiée (SAS)</li>
          <li><strong className="text-[#e8e8e8]">Siège social :</strong> [Adresse complète à compléter]</li>
          <li><strong className="text-[#e8e8e8]">Capital social :</strong> [Montant] €</li>
          <li><strong className="text-[#e8e8e8]">SIREN :</strong> [Numéro SIREN à compléter]</li>
          <li><strong className="text-[#e8e8e8]">RCS :</strong> [Ville] — [Numéro RCS]</li>
          <li><strong className="text-[#e8e8e8]">TVA intracommunautaire :</strong> [FR + numéro]</li>
          <li><strong className="text-[#e8e8e8]">Email :</strong> contact@mykurso.fr</li>
          <li><strong className="text-[#e8e8e8]">Téléphone :</strong> [Numéro de téléphone]</li>
        </ul>
      </LegalSection>

      <LegalSection title="2. Directeur de publication">
        <p>
          Le directeur de la publication est <strong>[Nom et Prénom]</strong>, en qualité de représentant légal de SAS Sanctuaire Consulting Services.
        </p>
      </LegalSection>

      <LegalSection title="3. Hébergement">
        <p>Le site Kurso est hébergé par :</p>
        <ul className="list-disc pl-5 space-y-1 text-[#a0a0ab]">
          <li><strong className="text-[#e8e8e8]">Hébergeur :</strong> Emergent Labs Inc.</li>
          <li><strong className="text-[#e8e8e8]">Site web :</strong> www.emergentagent.com</li>
          <li><strong className="text-[#e8e8e8]">Infrastructure :</strong> Cloud / Kubernetes</li>
          <li><strong className="text-[#e8e8e8]">Contact hébergeur :</strong> support@emergent.sh</li>
          <li><strong className="text-[#e8e8e8]">Adresse complète :</strong> [À compléter — contacter support@emergent.sh pour l'adresse officielle]</li>
        </ul>
        <p className="mt-2">
          Les données sont traitées conformément aux engagements contractuels conclus avec Emergent Labs Inc. incluant des garanties de niveau de protection équivalent au RGPD (clauses contractuelles types).
        </p>
      </LegalSection>

      <LegalSection title="4. Propriété intellectuelle">
        <p>
          L'ensemble du contenu du site Kurso (textes, graphismes, logo, icônes, structure, logiciels) est la propriété exclusive de Kurso SAS ou de ses partenaires et est protégé par le droit français et international de la propriété intellectuelle.
        </p>
        <p className="mt-2">
          Toute reproduction, représentation, modification, publication ou adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite sans autorisation préalable et écrite de Kurso SAS.
        </p>
        <p className="mt-2">
          Les contenus pédagogiques générés par l'IA à la demande de l'utilisateur sont soumis aux présentes conditions. L'utilisateur dispose d'une licence d'utilisation personnelle non exclusive et non transférable.
        </p>
      </LegalSection>

      <LegalSection title="5. Données personnelles">
        <p>
          Kurso collecte et traite des données personnelles conformément au Règlement Général sur la Protection des Données (RGPD — UE 2016/679) et à la loi Informatique et Libertés modifiée.
        </p>
        <p className="mt-2">
          Pour en savoir plus sur nos pratiques en matière de protection des données, consultez notre{' '}
          <a href="/politique-de-confidentialite" className="text-[#ff6b6b] hover:underline">
            Politique de confidentialité
          </a>.
        </p>
        <p className="mt-2">
          <strong>DPO :</strong> dpo@mykurso.fr
        </p>
      </LegalSection>

      <LegalSection title="6. Cookies">
        <p>
          Le site Kurso utilise des cookies à des fins techniques et analytiques. Vous pouvez gérer vos préférences via notre bannière de consentement ou consulter notre{' '}
          <a href="/cookies" className="text-[#ff6b6b] hover:underline">Politique cookies</a>.
        </p>
      </LegalSection>

      <LegalSection title="7. Limitation de responsabilité">
        <p>
          Kurso s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur ce site. Cependant, Kurso ne peut garantir l'exactitude, la précision ou l'exhaustivité des informations mises à disposition.
        </p>
        <p className="mt-2">
          Les contenus générés par l'intelligence artificielle sont fournis à titre informatif et éducatif uniquement. Ils ne constituent pas un conseil professionnel (médical, juridique, financier, etc.). L'utilisateur est seul responsable de l'usage qu'il en fait.
        </p>
        <p className="mt-2">
          Kurso ne saurait être tenu responsable des dommages directs ou indirects résultant de l'accès au site ou de l'utilisation des services.
        </p>
      </LegalSection>

      <LegalSection title="8. Droit applicable et juridiction">
        <p>
          Les présentes mentions légales sont soumises au droit français. En cas de litige, et après tentative de résolution amiable, les tribunaux compétents seront ceux du ressort du siège social de Kurso SAS.
        </p>
      </LegalSection>

      <LegalSection title="9. Contact">
        <p>
          Pour toute question relative aux présentes mentions légales, vous pouvez nous contacter à :{' '}
          <a href="mailto:contact@mykurso.fr" className="text-[#ff6b6b] hover:underline">contact@mykurso.fr</a>
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
